import { AppRootState } from '../../../../../../store/models/app-state.model';
import { StatisticsModel } from '../../models/statistics.model';

export const getStatisticsSelector = (state: AppRootState): StatisticsModel[] =>
  state.appsFeature.statistics.statistics;
